import { Box, Divider } from "@mui/material";

import { User } from "../../../../../types/types/user.types";

import About from "../../../components/About";
import EndorsedSkills from "../../../components/EndorsedSkills";
import Trophies from "../../../components/Trophies";
import Experience from "../../../components/Experience";
import Testimonials from "../../../components/Testimonials";

interface HomeTabProps {
  profile?: User;
  isLoading: boolean;
}

const HomeTab = ({ profile, isLoading }: HomeTabProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <About about={profile?.bio} isLoading={isLoading} />
      <EndorsedSkills />
      <Experience />
      <Trophies />
      <Testimonials />
    </Box>
  );
};

export default HomeTab;
